<template>
  <div class="card mb-4">
    <div class="card-header">
      <h2>Arbeidsongeschikte deelnemers</h2>
    </div>
    <div class="card-body">
      <template v-if="sickMembers.length">

        <p>De volgende deelnemers staan geregistreerd als arbeidsongeschikt. Meld ze weer aan door op <span class="far fa-check-circle txt-blue"></span> te klikken. Of pas hun arbeidsongeschiktheids- percentage aan.
        </p>
        <div v-for="(member, index) in sickMembers" :key="member.id" class="list-names">
          <div class="row justify-content-between align-items-center">
            <div class="col-12">
              <p>
                {{ member.name }} <a :href="member.tax_report_url" v-if="member.tax_report_url" target="_blank" rel="noopener nofollow"><i class="fa fa-file-alt"></i></a> <br>
                <small>Arbeidsongeschikt sinds {{ new Date(member.called_in_sick_on).toLocaleDateString('nl-NL', {month: 'long', year: 'numeric'}) }}</small>
                <br>
                <small v-if="member.show_sick_long">(verwachting: >4 weken)</small>
              </p>
            </div>
            <div class="col-12">
              <div class="input-group pull-left">
                <input type="text" class="form-control" v-model.trim.lazy="member.sick_percentage" @change="editPercentage(member)">
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
              <div class="text-right">
                <button type="button" class="btn btn-link" @click="callInBetter(member, index)">Beter melden <i class="far fa-check-circle txt-blue"></i></button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p>Er is momenteel niemand arbeidsongeschikt.</p>
      </template>
    </div>
  </div>

</template>

<script>
import {min, max} from 'vuelidate/lib/validators';

export default {
    props: {
        users: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            sickMembers: this.users,
            processing: false
        }
    },
    // validations() {
    //     return {
    //
    //         _.each(this.members, (member) => {
    //             return {
    //                 sick_percentage: {
    //                     minLength: min(1),
    //                     maxLength: max(1),
    //                 }
    //             }
    //
    //         })
    //     }
    // },
    methods: {
        editPercentage(member) {
            if (this.processing) {
                return false;
            }

            if (member.sick_percentage <= 1 || member.sick_percentage > 100) {
                this.$notify({
                    group: 'base',
                    text: 'Vul een geldig percentage in.',
                    type: 'alert-danger',
                });

                return;
            }

            let that = this;

            this.axios.post('change-percentage/' + member.id, {
                percentage: member.sick_percentage
            })
                .then(() => {
                    that.$notify({
                        group: 'base',
                        text: 'Het percentage arbeidsongeschiktheid van ' + member.name + ' is aangepast.',
                        type: 'alert-info',
                    });
                })
                .catch(() => {
                    that.$notify({
                        group: 'base',
                        text: 'Er is iets misgegaan met het veranderen van de percentages. Vernieuw de pagina om de actuele status te zien.',
                        type: 'alert-danger',
                    });
                })
                .finally(() => {
                    that.processing = false;
                });
        },
        callInBetter(member, index) {
            if (!confirm('Weet je zeker dat je deze persoon beter wilt melden?')) {
                return;
            }

            let that = this;

            this.axios.post('call-in-cured/' + member.id)
                .then(() => {
                    that.sick = false;

                    that.$notify({
                        group: 'base',
                        text: member.name + ' is weer beter gemeld!',
                        type: 'alert-info',
                    });

                    // Remove item
                    that.sickMembers.splice(index, 1);
                })
                .catch(() => {
                    that.$notify({
                        group: 'base',
                        text: 'Er is iets misgegaan met het beter melden. Vernieuw de pagina om de actuele status te zien.',
                        type: 'alert-danger',
                    });
                });
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/assets/components/SickMembers.vue